import React, { forwardRef, useEffect, useRef } from 'react';
import styles from './Checkbox.module.css';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: 'dark' | 'grey' | 'darkPurple' | 'transparent' | 'dark20x20';
  indeterminate?: boolean;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className = '', variant = 'dark', indeterminate, style, ...props }, ref) => {
    const defaultRef = useRef<HTMLInputElement>(null);
    const resolvedRef = (ref as React.RefObject<HTMLInputElement>) || defaultRef;

    useEffect(() => {
      if (resolvedRef.current) {
        resolvedRef.current.indeterminate = !!indeterminate;
      }
    }, [resolvedRef, indeterminate]);

    return (
      <label 
        className={`${styles.container} ${styles[variant]} ${className}`}
        style={style}
      >
        <input
          type="checkbox"
          ref={resolvedRef}
          className={styles.input}
          {...props}
        />
        <span className={styles.checkmark}></span>
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';